import React, { useState , useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import './css/Menu.css'
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import BaseMenu from './images/Menu/BaseMenu.png';
import DineIn from './images/Menu/DineIn.png';
import HomeDelivery from './images/Menu/HomeDelivery.png';
import HomeWeb from './images/Menu/HomeWeb.png';
import Parcel from './images/Menu/Parcel.png';
import pickup from './images/Menu/pickup.png';
import swiggy from './images/Menu/swiggy.png';
import zomato from './images/Menu/zomato.png';
import SideNavMob from './SideNavMob'
import Right from './images/Menu/chevron-right1.png';
import Lottie from "lottie-react";
import DeliveryLottie from './images/lotties/Delivery.json'
import ParcelLottei from './images/lotties/Parcel.json'
import { DBContext } from './DBContext' 
import NavBarMobile from './Mobile/NavBar'

function Menu() {

    const { logginedDB , sideNavState , sideNavStateFunc } = useContext(DBContext);

    const navigate = useNavigate();
    const toBaseMenu = () => {   
        navigate('/BaseMenuReg'); 
    }
    const toFoodScanner = () => {   
        navigate('/FoodMenuScanner'); 
    }

    const [sideNav,setSideNav] = useState(false)
    const handleSideNav = (state) => {
        setSideNav(state)
    }
    const [falseState,setFalseState] = useState(null)

    const [isHoveredDelivery, setIsHoveredDelivery] = useState(false);
    const [isHoveredParcel, setIsHoveredParcel] = useState(false);

  return (
    <div className='w-screen h-screen flex overflow-hidden'>
        <div className='w-full h-full hidden sm:flex sm:flex-col overflow-hidden'>
            <SherDineNav  sideNav={(state) => handleSideNav(state)} falseState={falseState}/>
            <div className='w-full bg-[#f5f5f5] flex gap-3 h-full'>
                <div className='w-max h-full z-[9999]'>
                    <SideNav focus={'Menu'}  state={sideNav} falseState={(state) => setFalseState(state)}/>
                </div>
                <div className='w-full h-full flex flex-col pr-3 pl-0 pb-3 pt-0 gap-3 overflow-hidden'>
                    <div className="pr-3 h-max w-full bg-[#fff] borderBottom">
                        <TopRootDiv image={'Menu Management'} root={['Menu Management']}/>
                    </div>
                    <div className='w-full h-full overflow-auto flex flex-col p-3 font-nunito text-[1.15em] text-nowrap font-[600] relative'>
                        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3'>
                            <div className='flex justify-center bg-[#fff] items-center rounded-[.313rem] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toBaseMenu}>
                                <img className='w-[3rem]' src={BaseMenu} alt="BaseMenu" />
                                <span className=''>Base Menu</span>
                                <img className='w-[.5rem]' src={Right} alt=">" />
                            </div>
                            <div className='flex justify-center items-center bg-[#fff] rounded-[.313rem] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toBaseMenu} 
                                onMouseEnter={() => setIsHoveredDelivery(true)}
                                onMouseLeave={() => setIsHoveredDelivery(false)}>
                                <img className='w-[3rem]' src={HomeDelivery} alt="BaseMenu" />
                                {/* <Lottie className='h-max' animationData={DeliveryLottie} loop={isHoveredDelivery} /> */}
                                <span className=''>Home Delivery</span>
                                <img className='w-[.5rem]' src={Right} alt=">" />
                            </div>
                            <div className='flex justify-center items-center rounded-[.313rem] bg-[#fff] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toBaseMenu}
                                onMouseEnter={() => setIsHoveredParcel(true)}
                                onMouseLeave={() => setIsHoveredParcel(false)}>
                                <img className='w-[3rem]' src={Parcel} alt="BaseMenu" />
                                {/* <Lottie className='h-max p-0 m-0' animationData={ParcelLottei} loop={isHoveredParcel} /> */}
                                <span className=''>Parcel</span>
                                <img className='w-[.5rem]' src={Right} alt=">" />
                            </div>
                            <div className='flex justify-center items-center bg-[#fff] rounded-[.313rem] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toBaseMenu}>
                                <img className='w-[3rem]' src={DineIn} alt="BaseMenu" />
                                <span className=''>Dine in</span>
                                <img className='w-[.5rem]' src={Right} alt=">" />
                            </div>
                            <div className='flex justify-center bg-[#fff] items-center rounded-[.313rem] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toBaseMenu}>
                                <img className='w-[3rem]' src={HomeWeb} alt="BaseMenu" />
                                <span className=''>Home Website</span>
                                <img className='w-[.5rem]' src={Right} alt=">" />
                            </div>
                            <div className='flex justify-center items-center bg-[#fff] rounded-[.313rem] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toFoodScanner}>
                                <img className='w-[3rem]' src={pickup} alt="toFoodScannerQr" />
                                <span className=''>Menu QR</span> 
                                <img className='w-[.5rem]' src={Right} alt=">" />
                            </div>
                            <div className='flex justify-center items-center rounded-[.313rem] bg-[#fff] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toBaseMenu}>
                                <img className='w-[3rem]' src={zomato} alt="BaseMenu" />
                                <span className=''>Zomato</span>
                                <img className='w-[.5rem]' src={Right} alt=">" />
                            </div>
                            <div className='flex justify-center items-center bg-[#fff] rounded-[.313rem] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toBaseMenu}>
                                <img className='w-[3rem]' src={swiggy} alt="BaseMenu" />
                                <span className=''>Swiggy</span>
                                <img className='w-[.5rem]' src={Right} alt=">" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* .......................................mobile_View.................................... */}

        <div className='w-full h-full flex flex-col sm:!hidden overflow-hidden'>
            <div className='w-full h-max sticky top-0'>
                <NavBarMobile title={'Menu Management'}/>
            </div>
            <div className='relative w-full h-full overflow-hidden' onClick={(e) =>sideNavStateFunc(true)}>
                <div className={`h-full w-max absolute left-0 bg-[#f5f5f5] transition-transform duration-5000 z-[9999] ${
                    sideNavState ? "translate-x-0 ease-out shadow-[5px_5px_100px_rgba(0,0,0,0.4)]" : "-translate-x-full ease-in duration-5000"
                }`}>
                    <SideNavMob focus={'Menu'} state={sideNav} falseState={(state) => setFalseState(state)}/>
                </div>
                <div className='w-full h-full overflow-auto noScroll flex flex-col p-3 font-nunito text-[1rem] text-nowrap font-[600]'>
                    <div className='w-full h-max grid grid-cols-12 gap-3'>
                        <div className='relative col-span-12 lg_mob:col-span-6 xl_mob:col-span-5 flex justify-start bg-[#fff] items-center rounded-[.313rem] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toBaseMenu}>
                            <img className='w-[3rem]' src={BaseMenu} alt="BaseMenu" />
                            <span className=''>Base Menu</span>
                            <img className='absolute right-3 w-[.5rem]' src={Right} alt=">" />
                        </div>
                        <div className='relative col-span-12 lg_mob:col-span-6 xl_mob:col-span-7 flex justify-start items-center bg-[#fff] rounded-[.313rem] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toBaseMenu} 
                            onMouseEnter={() => setIsHoveredDelivery(true)}
                            onMouseLeave={() => setIsHoveredDelivery(false)}>
                            <img className='w-[3rem]' src={HomeDelivery} alt="BaseMenu" />
                            <span className=''>Home Delivery</span>
                            <img className='absolute right-3 w-[.5rem]' src={Right} alt=">" />
                        </div>
                        <div className='relative col-span-12 md_mob:col-span-6  xl_mob:col-span-6 flex justify-start items-center bg-[#fff] rounded-[.313rem] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toBaseMenu}>
                            <img className='w-[3rem]' src={DineIn} alt="BaseMenu" />
                            <span className=''>Dine in</span>
                            <img className='absolute right-3 w-[.5rem]' src={Right} alt=">" />
                        </div>
                        <div className='relative col-span-12 md_mob:col-span-6 flex justify-start items-center rounded-[.313rem] bg-[#fff] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toBaseMenu}
                            onMouseEnter={() => setIsHoveredParcel(true)}
                            onMouseLeave={() => setIsHoveredParcel(false)}>
                            <img className='w-[3rem]' src={Parcel} alt="BaseMenu" />
                            <span className=''>Parcel</span>
                            <img className='absolute right-3 w-[.5rem]' src={Right} alt=">" />
                        </div>
                        <div className='relative col-span-12 lg_mob:col-span-6 flex justify-start bg-[#fff] items-center rounded-[.313rem] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toBaseMenu}>
                            <img className='w-[3rem]' src={HomeWeb} alt="BaseMenu" />
                            <span className=''>Home Website</span>
                            <img className='absolute right-3 w-[.5rem]' src={Right} alt=">" />
                        </div>
                        <div className='relative col-span-12 lg_mob:col-span-6 flex justify-start items-center bg-[#fff] rounded-[.313rem] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toFoodScanner}>
                            <img className='w-[3rem]' src={pickup} alt="BaseMenu" />
                            <span className=''>Pickup Menu QR</span>
                            <img className='absolute right-3 w-[.5rem]' src={Right} alt=">" />
                        </div>
                        <div className='relative col-span-12 md_mob:col-span-6 flex justify-start items-center rounded-[.313rem] bg-[#fff] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toBaseMenu}>
                            <img className='w-[3rem]' src={zomato} alt="BaseMenu" />
                            <span className=''>Zomato</span>
                            <img className='absolute right-3 w-[.5rem]' src={Right} alt=">" />
                        </div>
                        <div className='relative col-span-12 md_mob:col-span-6 flex justify-start items-center bg-[#fff] rounded-[.313rem] gap-3 cursor-pointer p-3 shadow-md hover:shadow-lg' onClick={toBaseMenu}>
                            <img className='w-[3rem]' src={swiggy} alt="BaseMenu" />
                            <span className=''>Swiggy</span>
                            <img className='absolute right-3 w-[.5rem]' src={Right} alt=">" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
  )
}

export default Menu
